var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.917 20.5c-5.284 0-9.584-4.3-9.584-9.583 0-5.284 4.3-9.584 9.584-9.584s9.583 4.3 9.583 9.584-4.3 9.583-9.583 9.583Zm0-20C5.163.5.5 5.163.5 10.917s4.663 10.416 10.417 10.416 10.416-4.662 10.416-10.416C21.333 5.163 16.671.5 10.917.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.625 6.778-.59-.59-4.124 4.125L6.806 6.21l-.589.589 4.105 4.105-4.105 4.105.589.59 4.105-4.106 4.125 4.125.59-.59-4.126-4.124 4.125-4.125"
  })));
};
export default SvgCrossCircle;